// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__15vDP","footer":"ModalError_footer__SkqiZ"};